import { Slider } from '@tempmee/react';
import { useEffect, useState } from 'react';
import { TestimonialCard } from './TestimonialCard';
import type { ITestimonial } from './types';

export interface ITestimonialsCarouselProps {
  testimonials: ITestimonial[];
  autoPlayMs?: number;
}

const DEFAULT_AUTO_PLAY_MS = 10_000;

const buildDotLabel = (index: number) => `Go to testimonial ${index + 1}`;

export const TestimonialsCarousel = ({
  testimonials,
  autoPlayMs = DEFAULT_AUTO_PLAY_MS,
}: ITestimonialsCarouselProps) => {
  const [current, setCurrent] = useState(0);

  // Re-runs whenever `current` changes — so a manual click resets the
  // autoplay clock, keeping every transition exactly `autoPlayMs` apart.
  useEffect(() => {
    if (testimonials.length <= 1) return undefined;
    const id = setTimeout(() => {
      setCurrent((i) => (i + 1) % testimonials.length);
    }, autoPlayMs);
    return () => clearTimeout(id);
  }, [testimonials.length, autoPlayMs, current]);

  if (testimonials.length === 0) return null;
  const active = testimonials[current];

  return (
    <div data-testid="testimonials-carousel">
      <TestimonialCard
        quote={active.quote}
        author={active.author}
        role={active.role}
        footer={
          <div data-testid="testimonials-dots">
            <Slider
              total={testimonials.length}
              current={current}
              onSelect={setCurrent}
              getDotLabel={buildDotLabel}
            />
          </div>
        }
      />
    </div>
  );
};
